<template>
  <div class="order-history-wrap emb-card pa-4">
    <h4 class="mb-4">{{orderSection.Order_History_Title}}</h4>

    <template>
      <v-data-table
        :headers="headers"
        :items="tableData"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="keyword1"
        show-expand
        class="elevation-1"
      >
        <!-- <template v-slot:top>
          <v-toolbar flat>
           
            <v-spacer></v-spacer>
            <v-switch v-model="singleExpand" label="Single expand" class="mt-2"></v-switch>
          </v-toolbar>
        </template> -->
        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <div id="payment-receipt">
              <div class="py-sm-12 py-8 px-sm-6 px-4">
                <span v-if="item.nested2!=undefined && item.nested2!=null && item.nested2">
                  <v-layout row wrap mb-6>
                    <v-flex xs12 sm6 md6 lg6 xl6>
                      <h6>Billing Address</h6>
                      <p class="mb-1" style="white-space: initial;">{{item.text4}}</p>
                      <p class="mb-1">{{item.text5}}</p>
                      <p class="mb-1">{{item.text6}}</p>
                    </v-flex>
                    <v-flex xs12 sm6 md6 lg6 xl6>
                      <h6>Shipping Address</h6>
                      <p class="mb-1" style="white-space: initial;">{{item.text3}}</p>
                      <p class="mb-1">{{item.text7}}</p>
                      <p class="mb-1">{{item.text8}}</p>
                    </v-flex>
                  </v-layout>
                  <template v-for="(cart, index) in item.nested2">
                    <div
                      class="layout row wrap align-center d-flex my-0 text-md-left text-center"
                      v-if="item.nested2"
                      :key="index"
                    >
                      <v-flex xs12 sm12 md3 lg3 xl3>
                        <img alt="cart Image" width="100" :src="cart.Product_Image_626_x_800px" />
                      </v-flex>
                      <v-flex xs12 sm4 md3 lg3 xl3>
                        <!-- <h6>{{paymentSection.Product_Name_Label}}</h6> -->
                        <p class="mb-0 font-weight-bold">{{cart.Name}}</p>
                        <p class="mb-0" v-if="cart.Color">Color : {{cart.Color}}</p>
                        <p class="mb-0" v-if="cart.Size">Size : {{cart.Size}}</p>
                      </v-flex>

                      <v-flex xs6 sm4 md3 lg3 xl3>
                        <!-- <h6>{{paymentSection.Price}}</h6> -->
                        <p
                          class="mb-0"
                        >{{cart.quantitySelected}} x {{ $n((cart.itemCost),'currency',item.keyword5)}}</p>
                      </v-flex>
                      <v-flex xs6 sm4 md2 lg3 xl3>
                        <!-- <h6>{{paymentSection.Price}}</h6> -->
                        <p class="mb-0">{{ $n((cart.itemTotal),'currency',item.keyword5)}}</p>
                      </v-flex>
                    </div>
                  </template>
                  <div class="d-flex align-center justify-space-between mt-4 mb-4">
                    <div>
                      <p class="mb-0">{{paymentSection.Subtotal_Label}}</p>
                    </div>
                    <div>
                      <span>{{ $n((item.amount2),'currency',item.keyword5) }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-center justify-space-between mb-4">
                    <p class="mb-0">{{paymentSection.Shipping_Label}}</p>
                    <span>{{ $n((item.amount1),'currency',item.keyword5) }}</span>
                  </div>
                  <v-divider class="my-4"></v-divider>
                  <div class="d-flex align-center justify-space-between">
                    <h4>{{paymentSection.Total_Label}}</h4>
                    <h4>{{ $n((item.amount3),'currency',item.keyword5) }}</h4>
                  </div>
                </span>
              </div>
            </div>
          </td>
        </template>
      </v-data-table>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import gettingRestClientObject from "../../../services/utils/cms-helper";
export default {
  computed: {
    ...mapGetters(["rtlLayout", "selectedLocale"]),
  },
  data() {
    return {
      orderSection: "",
      singleExpand: true,
      expanded: [],
      headers: [
        { text: "Order Id", value: "keyword1", sortable: true },
        { text: "Mode of Payment", value: "text2", sortable: false },
        { text: "Date", value: "date1", sortable: false },
        { text: "Amount", value: "gAmount", sortable: false },
        { text: "", value: "data-table-expand" },
      ],
      tableData: [],
      paymentSection: "",
    };
  },
  mounted() {
    this.cmsRequestFunctions = gettingRestClientObject();
    this.getPageData();
    this.getPaymentPageData();
    this.getOrderHistory();
  },
  watch: {
    selectedLocale: function () {
      this.getPageData();
      this.getPaymentPageData();
      this.getOrderHistory();
    },
  },
  methods: {
    getPageData() {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";

      var config = {
        pageType: "Template/",
        pageUrl: "10 Order History/10 Order History/10 Order History.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          console.log(res);
          if (res.area_List) {
            var orderArea = self.cmsRequestFunctions.pluck(
              "Order_Section",
              res.area_List
            );
            self.orderSection = self.cmsRequestFunctions.getAllMapData(
              orderArea[0].component
            );
            // self.headers[0].text = self.orderSection.Order_Number_Label;
            self.headers[0].text = self.orderSection.Order_ID;
            self.headers[1].text = self.orderSection.ModeOfPayment_Label;
            self.headers[2].text = self.orderSection.Date;
            self.headers[3].text = self.orderSection.Price;
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
    getOrderHistory: async function () {
      var self = this;
      var user = localStorage.getItem("embryo");
      var userData = JSON.parse(user);
      var loginDetails = userData.user_data;
      var userName = loginDetails.loginId;
      var filterValue = "type='Booking' AND keyword2='" + userName + "'";
      var allData = await this.cmsRequestFunctions.getDbDataTableValue(
        filterValue,
        "date1"
      );
      console.log(allData);
      if (
        allData != undefined &&
        allData.data != undefined &&
        allData.status == 200
      ) {
        self.tableData = allData.data.data;
        // let format = "MMMM Do , YYYY";
        // let startdate = moment().format(format);

        self.tableData.forEach((item) => {
          item.date1 = moment(item.date1).format("MMMM Do , YYYY");

          item.gAmount = item.keyword5 + " " + item.amount3;
        });
      }
    },
    getPaymentPageData: function () {
      var self = this;
      var language = localStorage.Language ? localStorage.Language : "en";
      var config = {
        pageType: "Template/",
        pageUrl:
          "28  Final Payment Receipt/28  Final Payment Receipt/28  Final Payment Receipt.ftl",
        lang: language,

        successCallback: function (response) {
          var res = response.data;
          if (res.area_List) {
            var payment = self.cmsRequestFunctions.pluck(
              "Receipt_Section",
              res.area_List
            );
            self.paymentSection = self.cmsRequestFunctions.getAllMapData(
              payment[0].component
            );
          }
        },
        errorCallback: function (error) {
          console.log(error);
        },
      };
      this.cmsRequestFunctions.cmsRequest(config, language);
    },
  },
};
</script>

